import { render, staticRenderFns } from "./colaright.vue?vue&type=template&id=70acb213&scoped=true&"
import script from "./colaright.vue?vue&type=script&lang=js&"
export * from "./colaright.vue?vue&type=script&lang=js&"
import style0 from "./colaright.vue?vue&type=style&index=0&id=70acb213&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70acb213",
  null
  
)

export default component.exports